export default "__VITE_ASSET__$ZBf2MWF__"